import React, { useState } from "react";
import {
  Box,
  Container,
  Tabs,
  Tab,
  Typography,
  Paper,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import PageTitle from "../../../components/pagetitle/PageTitle";
import TDSCalculator from "./TDSCalculator";
import GSTCalculator from "./GSTCalculator";
import EMICalculator from "./EMICalculator";
import CalculateIcon from "@mui/icons-material/Calculate";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`calculator-tabpanel-${index}`}
      aria-labelledby={`calculator-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 4 }}>{children}</Box>}
    </div>
  );
};

const Calculator = () => {
  const [value, setValue] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabs = [
    {
      id: "tds",
      label: "TDS Calculator",
      icon: <ReceiptLongIcon />,
      component: <TDSCalculator />,
    },
    {
      id: "gst",
      label: "GST Calculator",
      icon: <CalculateIcon />,
      component: <GSTCalculator />,
    },
    {
      id: "emi",
      label: "EMI Calculator",
      icon: <AccountBalanceIcon />,
      component: <EMICalculator />,
    },
  ];

  return (
    <Box sx={{ bgcolor: "#f8f9fa", minHeight: "100vh", pb: 10 }}>
      <PageTitle pageTitle="Financial Calculators" pagesub="Knowledge Bank" />

      <Container
        maxWidth="lg"
        sx={{ mt: { xs: -4, md: -6 }, position: "relative", zIndex: 10 }}
      >
        <Paper
          elevation={0}
          sx={{
            borderRadius: "24px",
            overflow: "hidden",
            boxShadow: "0 10px 40px rgba(0,0,0,0.05)",
            border: "1px solid #eee",
          }}
        >
          <Box
            sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "#fff" }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              variant={isMobile ? "fullWidth" : "standard"}
              centered={!isMobile}
              sx={{
                "& .MuiTabs-indicator": {
                  height: 4,
                  borderRadius: "4px 4px 0 0",
                  backgroundColor: "var(--primary-color)",
                },
                "& .MuiTab-root": {
                  py: 3,
                  fontSize: "1rem",
                  fontWeight: 600,
                  textTransform: "none",
                  color: "#666",
                  "&.Mui-selected": {
                    color: "var(--primary-color)",
                  },
                },
              }}
            >
              {tabs.map((tab, index) => (
                <Tab
                  key={tab.id}
                  icon={tab.icon}
                  iconPosition="start"
                  label={tab.label}
                  sx={{ gap: 1 }}
                />
              ))}
            </Tabs>
          </Box>

          <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: "#fff" }}>
            {tabs.map((tab, index) => (
              <TabPanel key={tab.id} value={value} index={index}>
                {tab.component}
              </TabPanel>
            ))}
          </Box>
        </Paper>

        <Box sx={{ mt: 6, textAlign: "center" }}>
          <Typography
            variant="body2"
            sx={{
              color: "#777",
              maxWidth: "800px",
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            Disclaimer: These calculators are for informational purposes only.
            While we strive for accuracy, users should verify results with
            professional advisors before making financial decisions.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Calculator;
